import React, { useState, useEffect, useContext, useRef } from 'react';
import { Form,  Spinner, Row, Col, Card, ListGroup, Modal, InputGroup } from 'react-bootstrap';
import { format, addDays, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { NotificationContext } from '../../contexts/notification-context';
import { FaCalendarCheck, FaCheckCircle, FaClock, FaRegTimesCircle, FaTimesCircle, FaUser } from 'react-icons/fa';
import { useAuth } from '../../contexts/auth-context';
import { startConnection, confirmarPresenca, marcarFalta } from "../../components/notificacao-hub";
import ButtonSubmit from '../../components/button';
import profissionaisService from '../../api/profissionaisService';
import pacientesService from '../../api/pacientesService';
import agendamentosService from '../../api/agendamentosService';
import './index.css';

const AgendarPacientes = () => {
  const {user} = useAuth();
  const { addNotification } = useContext(NotificationContext);
  const [profissionais, setProfissionais] = useState([]);
  const [pacientes, setPacientes] = useState([]);
  const [sugestoesPacientes, setSugestoesPacientes] = useState([]);
  const [sugestoesProfissionais, setSugestoesProfissionais] = useState([]);
  const [horariosAgendados, setHorariosAgendados] = useState([]);
  const [dataSelecionada, setDataSelecionada] = useState(new Date());
  const [profissionalSelecionado, setProfissionalSelecionado] = useState(null);
  const [profissionalNome, setProfissionalNome] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [pacienteSelecionado, setPacienteSelecionado] = useState(null);
  const [loading, setLoading] = useState(false);
  const [diasDaSemana, setDiasDaSemana] = useState([]);
  const [agendamentoAtual, setAgendamentoAtual] = useState({ id: null, pacienteId: null, usuarioAlteracaoId: user.id });

  const inputRefPaciente = useRef(null);
  const sugestaoRefPaciente = useRef(null);
  const inputRefProfissional = useRef(null);
  const sugestaoRefProfissional = useRef(null);

  useEffect(() => {
    startConnection();
  }, []);

  const handleConfirmarPresenca = async (agendamentoAtual) =>{
    try{
      await  agendamentosService.confirmarPresenca(agendamentoAtual);

      const { paciente, horario, profissional} = agendamentoAtual;
      const nomeProfissional = profissional?.nome;
      const nomePaciente = paciente?.nome;
      const hora = horario.hora;

      await confirmarPresenca(profissional.id, nomeProfissional, nomePaciente, hora);
      
      fetchHorariosAgendados(dataSelecionada, profissionalSelecionado);
      }catch(err){
        console.log(err);
      }   
  }

  const handleMarcarFalta = async (agendamentoAtual) =>{
    try{
      await  agendamentosService.marcarFalta(agendamentoAtual);

      const { paciente, horario, profissional} = agendamentoAtual;
      const nomeProfissional = profissional?.nome;
      const nomePaciente = paciente?.nome;
      const hora = horario.hora;

      await marcarFalta (profissional.id, nomeProfissional, nomePaciente, hora);
      
      fetchHorariosAgendados(dataSelecionada, profissionalSelecionado);

      }catch(err){
        console.log(err);
      }   
  }

  const fetchAvailableDates = async (profissionalId) => {
    const today = new Date();
    const dates = [];
    for (let i = 0; i < 7; i++) {
      const date = addDays(today, i);
      if (date.getDay() !== 0) {
        const normalizedDate = format(date, 'yyyy-MM-dd');
        const agendamentos = await agendamentosService.listarPorProfissionaleData(normalizedDate, profissionalId);
        if (agendamentos && agendamentos.length > 0) {
          dates.push(date);
        }
      }
    }
    setDiasDaSemana(dates);
  };

  useEffect(() => {
    fetchProfissionais();
    fetchPacientes();
  }, []);

  useEffect(() => {
    if (profissionalSelecionado) {
      fetchAvailableDates(profissionalSelecionado);
    }
  }, [profissionalSelecionado]);

  useEffect(() => {
    if (profissionalSelecionado && dataSelecionada) {
      setHorariosAgendados([]);
      fetchHorariosAgendados(dataSelecionada, profissionalSelecionado);
    }
  }, [dataSelecionada, profissionalSelecionado]);

  const fetchProfissionais = async () => {
    try {
      const response = await profissionaisService.listar();
      
      setProfissionais(response);
    } catch (err) {
      console.error('Erro ao buscar profissionais:', err);
    }
  };

  const fetchPacientes = async () => {
    try {
      const response = await pacientesService.listar();

      setPacientes(response);
    } catch (err) {
      console.error('Erro ao buscar pacientes:', err);
    }
  };

  const handleProfissionalChange = (e) => {
    const { value } = e.target;
    setProfissionalNome(value);
    const profissional = profissionais.find(prof => prof.nome.toLowerCase() === value.toLowerCase());
    if (profissional) {
      setProfissionalSelecionado(profissional.id);
      setSugestoesProfissionais([]);
      fetchAvailableDates(profissional.id);
    } else {
      setProfissionalSelecionado(null);
      setHorariosAgendados([]);
    }
    const normalizedValue = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    const sugestoesFiltradas = profissionais.filter(prof => {
      const normalizedNome = prof.nome.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      return normalizedNome.includes(normalizedValue);
    });
    setSugestoesProfissionais(sugestoesFiltradas);
  };

  const fetchHorariosAgendados = async (data, profissionalId) => {
    try {

      const agendamentos = await agendamentosService.listarPorProfissionaleData(data, profissionalId);
      if (agendamentos) {
        setHorariosAgendados(agendamentos);
      }
    } catch (err) {
      console.error('Erro ao buscar horários agendados:', err);
    }
  };

  const handlePacienteChange = (e) => {
    const { value } = e.target;
    const normalizedValue = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    const sugestoesFiltradas = pacientes.filter(paciente => {
      const normalizedNome = paciente.nome.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
      return normalizedNome.includes(normalizedValue);
    });
    setSugestoesPacientes(sugestoesFiltradas);
  };

  const handleSugestaoClick = (paciente) => {
    setPacienteSelecionado(paciente);
    setSugestoesPacientes([]);
    setAgendamentoAtual((prevAgendamento) => ({
      ...prevAgendamento,
      pacienteId: paciente.id,
    }));
  };

  const handleSugestaoClickProfissional = (profissional) => {
    setProfissionalSelecionado(profissional.id);
    setProfissionalNome(profissional.nome);
    setSugestoesProfissionais([]);
  };

  const handleAgendar = (agendamentoId) => {
    setAgendamentoAtual({
      id: agendamentoId,
      pacienteId: 0,
      usuarioAlteracaoId: user.id
    });

    setShowModal(true);
  };

  const handleConfirmAgendar = async () => {
    if (!agendamentoAtual || !agendamentoAtual.pacienteId) {
      addNotification('warning', 'Por favor, selecione um paciente para o agendamento.');
      return;
    }
    setLoading(true);
    try {
      await agendamentosService.agendarPaciente(agendamentoAtual);
      addNotification('success', 'Agendamento realizado com sucesso!');
      setShowModal(false);
      setPacienteSelecionado(null);
      setProfissionalSelecionado(null);
      setProfissionalNome('');

      fetchHorariosAgendados(dataSelecionada, profissionalSelecionado);
    } catch (err) {
      console.error('Erro ao agendar paciente:', err);
      addNotification('danger', 'Erro ao agendar paciente. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleDataChange = (e) => {
    const novaData = parseISO(e.target.value);
    setDataSelecionada(novaData);
   
    if (profissionalSelecionado) {
      fetchHorariosAgendados(novaData, profissionalSelecionado); // Atualiza a lista de horários agendados
    }
  };

  const handleClickOutside = (event) => {
    if (
      inputRefPaciente.current &&
      !inputRefPaciente.current.contains(event.target) &&
      sugestaoRefPaciente.current &&
      !sugestaoRefPaciente.current.contains(event.target)
    ) {
      setSugestoesPacientes([]);
    }

    if (
      inputRefProfissional.current &&
      !inputRefProfissional.current.contains(event.target) &&
      sugestaoRefProfissional.current &&
      !sugestaoRefProfissional.current.contains(event.target)
    ) {
      setSugestoesProfissionais([]);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const clearInputProfissional = () => {
    setProfissionalNome('');
    setProfissionalSelecionado(null);
    setHorariosAgendados([]);
    setDiasDaSemana([]);
  };
  return (
    <div className="agendar-container">
      <Card className="agendar-card shadow-sm">
        <Card.Body>
          <Card.Title className="text-center mb-4">Agendar Paciente</Card.Title>
          <hr />
          <Row>
            <Col md={8}>
            <Form.Group controlId="profissional">
              <Form.Label>Profissional</Form.Label>
                <div className='input-group'>
                  <InputGroup.Text>
                      <FaUser />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    value={profissionalNome}
                    placeholder="Digite o nome do profissional"
                    onChange={handleProfissionalChange}
                    ref={inputRefProfissional}
                    autoComplete="off"
                  />
                  {profissionalNome && (
                    <span onClick={clearInputProfissional}  style={{
                      cursor: 'pointer',
                      position: 'absolute',
                      right: '10px', 
                      top: '50%',
                      transform: 'translateY(-50%)', 
                      zIndex: 1,
                    }}>
                      <FaRegTimesCircle  />
                    </span>
                  )}
                </div>
                {sugestoesProfissionais.length > 0 && (
                  <ListGroup ref={sugestaoRefProfissional}>
                    {sugestoesProfissionais.map(profissional => (
                      <ListGroup.Item key={profissional.id} action onClick={() => handleSugestaoClickProfissional(profissional)}>
                          <b>{profissional.nome}</b>
                          <div>
                            <div>
                              {profissional.especialidade?.nome}
                            </div>
                            <div>
                              {` ${profissional.numeroRegistro}-${profissional.ufConselho}`}
                            </div>
                          </div>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group controlId="data">
                <Form.Label>Data</Form.Label>
                <InputGroup>
                <InputGroup.Text>
                      <FaClock />
                    </InputGroup.Text>
                    <Form.Control 
                      as="select" 
                      className="form-select"
                      name="horario" 
                      value={format(dataSelecionada, "yyyy-MM-dd")} 
                      onChange={handleDataChange} 
                      required
                    >
                      <option value="">Selecione um horário</option>
                      {diasDaSemana.map((date, index) => (
                                <option key={index} value={format(date, "yyyy-MM-dd")}>
                                  {format(date, 'dd/MM/yyyy (EEEE)', { locale: ptBR })}
                                </option>
                              ))}
                    </Form.Control>                           
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>

          <table className="mt-3 custom-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Nome do Paciente</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
               {horariosAgendados.map(agendamento => (
                <tr id={agendamento.id} key={agendamento.id}>
                  <td className="align-middle text-center fw-bold first-column">
                    {parseInt(agendamento.horario.horario.split(':')[0], 10)}h
                  </td>
                  <td>{agendamento.paciente?.nome}</td>
                  <td>{agendamento.paciente ? agendamento?.descricaoStatus : "-"}</td>
                  <td>
                    {agendamento.paciente ? (
                      <>
                        {agendamento.status === 1 ? (
                          <>
                            <FaCheckCircle
                              className="icon-action"
                              style={{ color: 'green', cursor: 'pointer', marginRight: '10px' }}
                              onClick={() => handleConfirmarPresenca(agendamento)}
                              title="Confirmar Presença"
                            />
                            <FaTimesCircle
                              className="icon-action"
                              style={{ color: 'red', cursor: 'pointer' }}
                              onClick={() => handleMarcarFalta(agendamento)}
                              title="Marcar Falta"
                            />
                          </>
                        ) : agendamento.status === 2 ? (
                          <FaCheckCircle
                            className="icon-action"
                            style={{ color: 'green', cursor: 'not-allowed', marginRight: '10px' }}
                            title="Presença Confirmada"
                          />
                        ) : agendamento.status === 3 ? (
                          <FaTimesCircle
                            className="icon-action"
                            style={{ color: 'red', cursor: 'not-allowed' }}
                            title="Falta Marcada"
                          />
                        ) : null}
                      </>
                    ) : (
                      <FaCalendarCheck 
                        className="icon-action"
                        style={{ color: 'green', cursor: 'pointer', marginRight: '10px' }}
                        onClick={() => handleAgendar(agendamento.id)}
                        title="Agendar"
                      />
                    )}
                  </td>

                </tr>
              ))}
            </tbody>
          </table>

          <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Agendar Paciente</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Group controlId="paciente">
                <Form.Label>Paciente</Form.Label>
                <Form.Control
                  type="text"
                  value={pacienteSelecionado?.nome}
                  placeholder="Digite o nome do paciente"
                  onChange={handlePacienteChange}
                  ref={inputRefPaciente}
                  autoComplete="off"
                />
                <ListGroup>
                  {sugestoesPacientes.map(sugestao => (
                    <ListGroup.Item key={sugestao.id} action onClick={() => handleSugestaoClick(sugestao)} ref={sugestaoRefPaciente}>
                      <div><b>{sugestao.nome}</b></div>
                      { sugestao.menorIdade && sugestao.responsavel && (
                        <div style={{ fontSize: '0.85em', color: '#6c757d' }}>
                          <div>
                            {sugestao.responsavel?.nome}
                          </div>
                          <div>
                            {format(sugestao.dataNascimento, 'dd/MM/yyyy', { locale: ptBR })}
                          </div>
                        </div>
                      )}
                    </ListGroup.Item>
                  ))}
                  {sugestoesPacientes.length > 0 &&(
                   <ListGroup.Item action href="/pacientes">
                    <b>Cadastrar novo paciente</b>
                  </ListGroup.Item>)}
                </ListGroup>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <ButtonSubmit variant="success" onClick={handleConfirmAgendar} disabled={loading}>
                {loading ? <Spinner animation="border" size="sm" /> : 'Agendar'}
              </ButtonSubmit>
            </Modal.Footer>
          </Modal>
        </Card.Body>
      </Card>
    </div>
  );
};

export default AgendarPacientes;
